// This is a list of fields that show under the "document information" of a record details page and not in the main person section.
const documentLevelFields = [
  'BOOKNO',
  'DIGITAL_GS_NUMBER',
  'EVENT_DISTRICT',
  'EXT_ARC_ID',
  'EXT_FILM_NBR',
  'EXT_PUB_NBR',
  'EXT_PUB_TITLE',
  'EXT_REPOSITORY_NAME',
  'FILM_NUMBER',
  'FOLDER',
  'FS_DIGITAL_FILM_NBR',
  'FS_FILM_NBR',
  'FS_IMAGE_NBR',
  'FS_RECORD_GROUP',
  'FS_SYSTEM_OF_ORIGIN',
  'FS_UDE_BATCH_NBR',
  'FS_UNIQUE_ID',
  'HOUSEHOLD_ID',
  'IMAGE_NBR',
  'ITEMNO',
  'LINE_NBR',
  'NARA_PUBLICATION_NUMBER',
  'NARA_PUBLICATION_TITLE',
  'NARA_ROLL_NUMBER',
  'NOTE_SOURCE',
  'PUBLISHABLE_ROLL_NUMBER',
  'RECORD_GROUP',
  'REF_ID',
  'SHEET_LTR',
  'SHEET_NUMBER',
  'SHEET_NUMBER_LETTER',
  'SOURCE_BOOK_NBR',
  'SOURCE_COMPOSITE',
  'SOURCE_HOUSEHOLD_ID',
  'SOURCE_LINE_NBR',
  'SOURCE_RECORD_TYPE',
  'SOURCE_REFERENCE',
  'SOURCE_SHEET_NBR_LTR',
  'UDE_BATCH_NUMBER',
  'UNIQUE_IDENTIFIER',
  'PAGE',
]
export default documentLevelFields
